import { motion } from 'motion/react';

/**
 * Полноэкранный слой под шапкой лобби: затемнение по ширине, контент в колонке max 896px.
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @param {() => void} [props.onBackdropClick]
 * @param {boolean} [props.contentBleed] — не обрезать контент (напр. Live2D на весь фон карточки)
 */
export default function GameLobbyLayer({ children, onBackdropClick, contentBleed = false }) {
  const clip = contentBleed ? 'overflow-visible' : 'overflow-hidden';
  return (
    <div className="pointer-events-auto absolute inset-0 z-[42] flex min-h-0 flex-col">
      <motion.div
        className="absolute inset-0 z-0 bg-black/55"
        aria-hidden
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.18 }}
        onClick={onBackdropClick}
      />
      <div className={`relative z-10 flex min-h-0 flex-1 justify-center ${clip}`}>
        <motion.div
          className={`flex h-full w-full max-w-[896px] flex-col border-x border-[rgba(237,232,229,0.14)] bg-game-page shadow-2xl ${clip}`}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: 'spring', damping: 24, stiffness: 340 }}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
}